export default "__VITE_ASSET__4630039b__"